import { Component } from '@angular/core';
import { WarrantyType } from 'src/app/models/warrantytype.interface';
import { Train } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { Router } from '@angular/router';
import { Warrantycondition } from 'src/app/models/warrantycondition.model';
import { warrantyconditionService } from 'src/app/services/warrantyconditions/warrantycondition.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-warranty',
  templateUrl: './add-warranty.component.html',
  styleUrls: ['./add-warranty.component.scss']
})
export class AddWarrantyComponent {
  public Wtypes: Array<WarrantyType> = [
    { Id: 0, Name: 'Feed Pressure' },
    { Id: 1, Name: 'Permeate TDS' },
  ];
  constructor(
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private warrantyService:warrantyconditionService,
    private toastr : ToastrService
  ) {}
  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  CurrentUserId = this.loggedInuserRole.userId;
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  SelectedId: string;
  allTrainList: Train[] = [];
  plants: Plant[] = [];
  plantId: number;
  trainId: number;
  trainDetails: Train = new Train();
  dateNow: Date = new Date();
  addWarrantyRequest: Warrantycondition = new Warrantycondition();
  plantSelected: boolean = false;
  getSelectedId(e) {
   
    this.SelectedId = e.target.value;
    this.plantId = Number(this.SelectedId);
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
        console.log(this.allTrainList);
       
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
  getSelectedTrain(e)
  {
    this.SelectedId = e.target.value;
    this.trainId = Number(this.SelectedId);
    this.trainService.getTrainById(this.SelectedId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        this.addWarrantyRequest.Stage=this.trainDetails.Stages;
        console.log(this.trainDetails);
      },
    });

  }
  addwarranty() {
    
    const dateNowISO = this.dateNow.toISOString();

    this.addWarrantyRequest.CreatedAt = dateNowISO;
    this.addWarrantyRequest.UpdatedAt = dateNowISO;
    this.addWarrantyRequest.Warrantycondition1="test warranty";
    this.addWarrantyRequest.PlantId = this.plantId;
    this.addWarrantyRequest.TrainId = this.trainId;
   
    this.warrantyService.addWarranty(this.addWarrantyRequest).subscribe({
      next: (warrantycondition) => {
        console.log(this.addWarrantyRequest);
        if(warrantycondition.Id>0)
        {
          const id =  btoa(warrantycondition.Id.toString());
       
         
          this.toastr.success('Warranty Condition Added Successfully.', 'Information')
          this.router.navigate(['/component/warrantycondition/edit/' + id]);
        
        }
      },
      error: (response) => {
        if (response.error.length > 0) {
          this.toastr.error(response.error, 'Error');
        } else {
          this.toastr.error('Error While Creating Warranty Condition.', 'Error');
        }
      },
    });
  }
  ngOnInit(): void {
    
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
          this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
        },
      })
      
    }
    else
    {
   
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
        this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use

      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  // get trainId from breadcrumbs
     this.plantService.selectedTrain$
      .subscribe(trainId => {
        if (trainId) {
          this.getSelectedTrain({ target: { value: trainId.toString() } });
        }
      });

        // get plantId from breadcrumbs
     this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedId({ target: { value: plantId.toString() } });
        }
      });
  }
}

